import { getExternalUniqueId } from '../../utils'
import { getProduct } from '../../api'
import configModule from '../../config'

const config = configModule()
const businessId = config.aid
const clientId = config.apiKey
const twitterShare = config.twitterShareUrl
const facebookShare = config.facebookShareUrl

export const twitterShareUrl = (url) => `${twitterShare}?url=${encodeURIComponent(url)}`

export const facebookShareUrl = (url) => `${facebookShare}?u=${encodeURIComponent(url)}`

export const shareOnPlatform = (url, platform, useDefault = '') => {
  if (platform === 'twitter') return twitterShareUrl(useDefault)
  if (platform === 'facebook') return facebookShareUrl(url)
}

export const getProductUrlAndImages = async (review) => {
  const productId = getExternalUniqueId(review)

  const { data: retrievedProduct } = await getProduct({
    business_id: businessId,
    external_product_id: productId,
    client_id: clientId
  })

  return { productUrl: retrievedProduct.url, productImages: retrievedProduct.images }
}
